import React from "react";
export interface AlcoholModalProps {
  onConfirm: () => void;
  onClose: () => void;
}
export const AlcoholModal = (props: AlcoholModalProps): React.JSX.Element => {
  return (
    <div>
      <section className="container is-center-aligned-text">
        <h1>Age check</h1>

        <p className="is-large-text">
          The product you’ve selected is an age-restricted item — are you aged 18 years or over?
        </p>

        <p>
          Please confirm that you (the purchaser) and the person who will receive the items are 18 years or over. The person receiving the age-restricted items will be required to show an acceptable form of ID at the point of delivery. Please don’t be offended!
        </p>
      </section>

      <div className="is-stuck-bottom container">
        <button type="button" name="button" className="button is-primary is-full-width" onClick={props.onConfirm} data-testid="age-restriction-modal-confirm">
          Yes, I am over 18
        </button>
        <br></br>
        <button type="button" name="button" className="button is-full-width" onClick={props.onClose} data-testid="age-restriction-modal-close">
          No, take me back
        </button>
        <br></br>
      </div>
    </div>
  );
}
